import { getUrlParams, pushUrlParams } from "../../services/service-url-params";
import { typeAhead } from "../../services/service-typeAhead";

export default class GlobalSearch {
  constructor(element) {
    this.typeAheadQuery = "https://laka.ankiro.dk/Rest/global/TypeAhead.json"
    this.typeAheadArray = [];

    this.el = element;
    this.searchInput = this.el.querySelector("[data-searchinput]");
    this.seaarchButton = this.el.querySelector("[data-globalsearch]");
    this.searchResultPage = this.el.dataset.resultpage;
    this.TypeAheadContainer = this.el.querySelector("[data-typeahead]");

    this.enterSearchParam = this.enterSearchParam.bind(this);
    this.init()
  }

  init() {
    this.searchInput.addEventListener('keydown', e =>{
      if (e.keyCode === 13){
        if (this.searchInput.value.length >= 3){
          this.enterSearchParam();
          typeAhead(this.searchInput.value, this.typeAheadQuery, this.TypeAheadContainer, this.searchInput) 
        }
      }
      this.searchInput.addEventListener('keyup', e =>{
        if (e.keyCode != 13 && this.searchInput.value.length >=3 ){
          typeAhead(this.searchInput.value, this.typeAheadQuery, this.TypeAheadContainer, this.searchInput)          
        }else{
          this.TypeAheadContainer.classList.add("h-0");
          this.TypeAheadContainer.classList.remove("h-auto");
        }
      })
    })

    this.seaarchButton.addEventListener('click', e =>{
      if (this.searchInput.value.length >= 3){
        this.enterSearchParam();
      }
    })
  }

  enterSearchParam(){
    let query = this.searchInput.value;    
    document.location = `${this.searchResultPage}?query=${query}`
  }
}